import { Component } from '@angular/core';
import { PageHeaderComponent } from '@aston/foundation';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { TopBarComponent } from '../../components/top-bar/top-bar.component';
import { LayoutBaseComponent } from '../layout-base/layout-base.component';


@Component({
	selector: 'simple-layout',
	templateUrl: './simple-layout.component.html',
	imports: [RouterOutlet, PageHeaderComponent, LayoutBaseComponent, TopBarComponent, AsyncPipe]
})
export class SimpleLayoutComponent extends LayoutBaseComponent {
}
